import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, FieldLayout } from '@unowmooc/react-ui-kit'
import InputCopy from 'components/InputCopy'

const ResourcesPage = () => (
  <>
    <h2 style={{ marginBottom: '30px' }}>
      <FormattedMessage id="menu.supervisor.resources" />
    </h2>

    <Box>
      <FieldLayout label={<FormattedMessage id="supervisor.resources.tutoriel_impact_title" />}>
        <InputCopy id="tutoriel-impact-link" value="https://unow.fr/r/tutoriel-impact" />
      </FieldLayout>

      <FieldLayout label={<FormattedMessage id="supervisor.resources.kit_impact_title" />}>
        <InputCopy id="kit-impact-link" value="https://unow.fr/r/kit-embarquement-impact" />
      </FieldLayout>
    </Box>
  </>
)

ResourcesPage.propTypes = {}

export default ResourcesPage
